import { useSearchParams } from "react-router-dom"
// import CryptoJS from "crypto-js"

import { FullRow, MessageContainer, NormalText, Title } from "../components"
import { decodeHttpSafe } from "../config"



export function MessagePage(): JSX.Element {
  //takes title and content as input
  const [searchParams] = useSearchParams()
  const text=searchParams.get('q')??""

  const params=JSON.parse(decodeHttpSafe(text))
  
  return (
    <MessageContainer>
      <FullRow>
        <Title>{params.title}</Title>
      </FullRow>
      <FullRow>
        <NormalText> {params.content}</NormalText>
      </FullRow>
      
    </MessageContainer>
  )
}
  